import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useForm } from "react-hook-form";
import {
  onOrderBy,
  onRangeArray,
  onChangeIsAnswerDataQuestion,
} from "../selection";
import _ from "lodash";
import FooterQuestion from "../component/FooterQuestion";
import {
  onDispatchIndexQuestion,
  onDispatchDataAlert,
  onDispatchIsButtonNextQuestion,
} from "../../ListQuestion/actions";
import { onDispatchDataQuestion } from "../../../modules/ReadingBooks/actions";
import { AlertSuccess, AlertError } from "../selection";

const FillTheBlankWithNumber = ({
  data,
  indexQuestion,
  alert,
  isButtonNextQuestion,
  dataQuestion,
  onDispatchDataAlert,
  onDispatchIsButtonNextQuestion,
  onDispatchIndexQuestion,
  onDispatchDataQuestion,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isDirty, isValid },
  } = useForm({
    mode: "onChange",
  });
  const [createArrayNumber, setStateCreateArrayNumber] = useState([]);
  const [correctAnswer, setStateCorrectAnswer] = useState([]);
  useEffect(() => {
    const createArrayNumber = onOrderBy(
      onRangeArray(data.answer.start, data.answer.end, data.answer.range),
      data.answer.operators
    );
    const correctAnswer = onOrderBy(
      _.sampleSize(createArrayNumber, data.answer.number),
      data.answer.operators
    );
    setStateCreateArrayNumber(createArrayNumber);
    setStateCorrectAnswer(correctAnswer);
  }, [data]);

  const onSubmitForm = handleSubmit((value) => {
    const createValue = Object.keys(value).map((key) => Number(value[key]));
    const result = _.isEqual(createValue, correctAnswer);

    if (result) {
      const dataAlert = AlertSuccess;
      const newDataQuestion = onChangeIsAnswerDataQuestion(
        dataQuestion,
        data,
        2
      );

      onDispatchDataAlert(dataAlert);
      onDispatchIsButtonNextQuestion(true);
      onDispatchDataQuestion(newDataQuestion);
    } else {
      const dataAlert = AlertError;
      const newDataQuestion = onChangeIsAnswerDataQuestion(
        dataQuestion,
        data,
        3
      );
      onDispatchDataAlert(dataAlert);
      onDispatchDataQuestion(newDataQuestion);
    }
  });

  const onNextQuestion = (number) => {
    const dataAlert = {
      color: "",
      visible: false,
      text: "",
    };
    const newDataQuestion = onChangeIsAnswerDataQuestion(
      dataQuestion,
      data,
      number
    );
    onDispatchDataQuestion(newDataQuestion);
    onDispatchDataAlert(dataAlert);
    onDispatchIndexQuestion(indexQuestion + 1);
    onDispatchIsButtonNextQuestion(false);
    reset();
  };

  return (
    <Fragment>
      <div className="fill-the-black-number mt-4">
        <form id={data.question}>
          <div className="d-flex align-items-center">
            {createArrayNumber.map((item, index) => {
              if (_.includes(correctAnswer, item)) {
                return (
                  <Fragment key={index}>
                    <span>
                      <input
                        type="text"
                        style={{ width: "100px" }}
                        className="mr-1 ml-1"
                        name={index}
                        ref={register({ required: true })}
                        autoComplete="off"
                      />
                    </span>
                    {index != createArrayNumber.length - 1 && <span>,</span>}
                  </Fragment>
                );
              }
              return (
                <Fragment key={index}>
                  <span className="mr-1 ml-1">{item}</span>
                  {index != createArrayNumber.length - 1 && <span>,</span>}
                </Fragment>
              );
            })}
          </div>
        </form>
      </div>
      <FooterQuestion
        onSubmitForm={onSubmitForm}
        onNextQuestion={onNextQuestion}
        currentIndex={indexQuestion}
        questionList={dataQuestion}
        disabled={!isDirty || !isValid}
        isButtonNextQuestion={isButtonNextQuestion}
        alert={alert}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const { indexQuestion, alert, isButtonNextQuestion } = state.listQuestion;
  const { dataQuestion } = state.readingBookReducers;
  return {
    indexQuestion,
    dataQuestion,
    alert,
    isButtonNextQuestion,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onDispatchIndexQuestion,
      onDispatchDataAlert,
      onDispatchIsButtonNextQuestion,
      onDispatchDataQuestion,
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FillTheBlankWithNumber);
